import { getYear } from "date-fns";
// eslint-disable-next-line no-restricted-imports -- legacy, use @clipboard-health/date-time
import { utcToZonedTime } from "date-fns-tz";

export type TaxSeasonType = "tax-preparation" | "tax-filing";
interface TaxSeasonInfo {
  taxSeason: TaxSeasonType;
}

export function getTaxSeasonInfo(params: {
  taxationYear: number;
  timezone: string;
}): TaxSeasonInfo {
  const { taxationYear, timezone } = params;

  // Current year based on timezone
  const currentYear = getYear(utcToZonedTime(Date.now(), timezone));

  return { taxSeason: currentYear <= taxationYear ? "tax-preparation" : "tax-filing" };
}
